export const VISIBILITY_FILTERS = {
  ALL: "all",
  MEN: "men",
  WOMEN: "women",
  KIDS: "kids",
  SALE: "sale",
};
